import {createSelector} from 'reselect'
import {getLicenses} from '../../../selectors'

const getCardState = state => state.licenses.addUsersCard

export const getPrice = createSelector(
    getCardState,
    cardState => cardState.price
)

export const getUsersCount = createSelector(
    getCardState,
    (cardState) => cardState.currentUsersCountSelected
)

export const isSelectUnlimitedUsers = createSelector(
    getCardState,
    (cardState) => cardState.unlimited
)

export const getCurrentLicenseId = createSelector(
    getCardState,
    (cardState) => cardState.licenseId
)

export const getCurrentlyLicencedUsersCount = createSelector(
    getCurrentLicenseId,
    getLicenses,
    (licenseId, licenses) => licenseId ? licenses.find((license) => license.id === licenseId).usersCount : 0
)

export const getCurrentLicenceStartDate = createSelector(
    getCurrentLicenseId,
    getLicenses,
    (licenseId, licenses) => licenseId ? new Date(licenses.find((license) => license.id === licenseId).startDate) : 0
)

export const getCurrentLicenceEndDate = createSelector(
    getCurrentLicenseId,
    getLicenses,
    (licenseId, licenses) => licenseId ? new Date(licenses.find((license) => license.id === licenseId).endDate) : 0
)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/licenseList/addUsers/selectors.js